import { DEFAULT_LANGUAGE, Language, REGISTERED_LANGUAGES } from '../constants/i18n';

export function capitalize(str: string) {
    return `${str[0].toUpperCase()}${str.slice(1)}`;
}

const isValidLanguage = (languageId: string): languageId is Language =>
    REGISTERED_LANGUAGES.includes(languageId as Language);

export function normalizeLanguage(language?: string) {
    let normalizedLanguage = '';

    if (typeof language === 'string') {
        normalizedLanguage = language.replace('_', '-');
    }
    if (normalizedLanguage && isValidLanguage(normalizedLanguage)) {
        return normalizedLanguage;
    }

    return DEFAULT_LANGUAGE;
}
